import { PropsWithChildren, createContext, useContext, useState } from 'react'

interface IStoreData {
  current: number
  options: string[]
  change: (tab: number) => void
}

const StoresContext = createContext<IStoreData>({} as IStoreData)

const StoresProvider = ({ children }: PropsWithChildren) => {
  const [selectedTab, setSelectedTab] = useState<number>(0)

  const tabOptions: string[] = ['Marketplace', 'Serviços', 'Ferramentas']

  const handleChangeTab = (tab: number) => setSelectedTab(tab)

  return (
    <StoresContext.Provider
      value={{
        current: selectedTab,
        options: tabOptions,
        change: handleChangeTab,
      }}
    >
      {children}
    </StoresContext.Provider>
  )
}

const useStore = (): IStoreData => useContext(StoresContext)

export { StoresProvider, useStore }
